module.exports = __webpack_public_path__ + "static/media/icon_lock_private.db883b8d.svg";